import React, { FC, useEffect, useState } from 'react'

import CrewEditForm from '../molecules/CrewEditForm';
import { useLocation, useParams } from 'react-router-dom';
import MainLayout from '../../Layouts/MainLayout';
import { service } from '../../../services/AxiosServices';


const CrewEditFormPage: FC = () => {
   

 
   const location = useLocation();
   // const { path, name ,crewName} = location.state  || location.state.name || {}
   const { id } = useParams<{ id: string }>();
   const [crewname,setCrewname] = useState('')
   useEffect(() => {
        // Fetch the crew name based on the project ID and crew ID
     const singleCrew = async () => {
       try {
         const response = await service<any>('/api/get-all-crew', 'post', {
           project_id: localStorage.getItem('project_id')
         });
         const formattedData = response.data.crews.find((ele:any) => ele.id == id)?.crew_name;
         if (formattedData) {
           setCrewname(formattedData);
         }
       } catch(err) {
         console.error('Error fetching crew name:', err);
       }
     };
     singleCrew();
   }, [id]); 
 
   return (
      <>
         <MainLayout>
            <CrewEditForm crewId={id}  name={ crewname|| 'crew ' } />
         </MainLayout>
      </>
   )
}
export default CrewEditFormPage;